import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-md border-b border-background-700/50'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 group cursor-pointer"
            title="天美影视首页"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-950">
              <i className="ri-movie-2-line text-lg"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-50">
              天美影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'text-primary-500'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/dongzuo"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              电影分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'text-primary-500'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-48 px-4 py-2 text-sm rounded-full bg-background-700/50 border border-background-600/50 text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 focus:w-64 transition-all duration-300"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-b border-background-700/50">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className={`block text-sm font-medium py-2 cursor-pointer ${
                isActive('/') ? 'text-primary-500' : 'text-foreground-300'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/dongzuo"
              className={`block text-sm font-medium py-2 cursor-pointer ${
                location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-300'
              }`}
            >
              电影分类
            </Link>
            <Link
              to="/about"
              className={`block text-sm font-medium py-2 cursor-pointer ${
                isActive('/about') ? 'text-primary-500' : 'text-foreground-300'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}